import { Heading, Button as RACButton } from "react-aria-components";
import { Button } from "../button";
import { Icon } from "../icons";

export function DateInputCalendarHeader() {
	return (
		<header className="flex items-center gap-1 pb-4 px-1 border-box">
			<RACButton
				slot="previous"
				render={({ children, ...props }: any) => (
					<Button
						icon={<Icon name="ChevronLeft" />}
						variant="ghost"
						{...props}
					/>
				)}
			/>
			<Heading className="flex-1 font-sans font-semibold [font-variation-settings:normal] text-base text-center mx-2 my-0 text-neutral-900 dark:text-neutral-200" />
			<RACButton
				slot="next"
				render={({ children, ...props }: any) => (
					<Button
						icon={<Icon name="ChevronRight" />}
						variant="ghost"
						{...props}
					/>
				)}
			/>
		</header>
	);
}
